// extracted by mini-css-extract-plugin
export default {"generic-link-decoration":"GenericLink_generic-link-decoration__nS3z1"};